import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'

const SelectUser = ({ options, onChange, label, value, required }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id={`${() => label.trim()}-label`}>{label}</InputLabel>
      <Select
        labelId={`${() => label.trim()}-label`}
        label={label}
        id={`${() => label.trim()}`}
        value={value}
        onChange={onChange}
        required={required}
      >
        {options.map((option) => (
          <MenuItem value={option._id} key={option._id}>
            <Box display="flex" gap={1}>
              <Avatar src={option.photograph} sx={{ width: 18, height: 18 }} />
              <Typography variant="caption">
                {option.firstName} {option.lastName}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectUser
